module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("Choose from 9 different washes")]), _vm._v(" "), _c('v-touch', {
    ref: "dialbox",
    staticClass: "dial-container",
    attrs: {
      "pan-options": {
        direction: 'horizontal',
        threshold: 50
      }
    },
    on: {
      "panstart": _vm.panStart,
      "pan": _vm.handlePan,
      "panend": _vm.panStop
    }
  }, [_c('div', {
    ref: "dial",
    class: {
      'wash-dial': true, 'has-selected': _vm.selectedOption !== null
    }
  }, [_vm._l((_vm.washOptions), function(option, index) {
    return _c('v-touch', {
      key: index,
      class: {
        'wash-option': true, 'selected': _vm.selectedOption !== null && _vm.selectedOption.img === option.img
      },
      style: ({
        transform: 'rotate(' + ((36 * index) + _vm.dialRotation) + 'deg)'
      }),
      on: {
        "tap": function($event) {
          _vm.selectOption(index)
        }
      }
    }, [_c('div', {
      staticClass: "sticker",
      style: ({
        transform: 'rotate(' + (-_vm.dialRotation - (36 * index)) + 'deg)',
        'background-image': 'url(/static/' + option.img + ')'
      })
    })])
  }), _vm._v(" "), (_vm.selectedOption) ? _c('div', {
    staticClass: "wash-description"
  }, [_c('h3', [_vm._v(_vm._s(_vm.selectedOption.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.selectedOption.content))])]) : _vm._e()], 2)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("./assets/warriorhead.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v("WARRIOR WASH!")]), _vm._v(" "), _c('div', {
    staticClass: "tagline"
  }, [_vm._v("Self Service Car Wash")])]), _vm._v(" "), _c('div', {
    staticClass: "head-content"
  }, [_c('img', {
    staticClass: "wash-image",
    attrs: {
      "src": require("./assets/home.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n            309 Main St, Santa Rosa, TX 78593\n            "), _c('br'), _vm._v("\n            Open 24/7\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("$1.00 to start"), _c('br'), _vm._v("4 minute wash")]), _vm._v(" "), _c('img', {
    staticClass: "coins",
    attrs: {
      "src": require("./assets/coins.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "coin",
    attrs: {
      "src": require("./assets/coin.svg")
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "inline-text"
  }, [_vm._v("= 1 extra minute")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39dbb80a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 12
// module chunks = 0